<template>
	<div>
	<div class="promotion-campaign-filters promotion-table-filters ad-d-flex ad-d-flex-between">
			  <div class="promotion-table-filters-left-part ad-d-flex ad-d-flex-start">
			     <div class="ad-d-flex">
				    <el-button size="small" type="primary" @click="cOpenDrawer"  icon="el-icon-plus">新建广告计划</el-button>
					<el-button size="small" icon="el-icon-edit" disabled>批量修改</el-button>
					<el-button size="small" @click="openCopyModal" style="margin-right:10px;" icon="el-icon-document-copy" :disabled="this.sels.length===0">批量复制</el-button>
					<el-tag type="info" @close="allAds" v-if="campaign_obj.id" closable>已选广告组:{{campaign_obj.name}}</el-tag>
				 </div>
			  </div>
			</div>
			<el-dialog
			  title="广告计划复制"
			  :visible.sync="dialogCopyVisible"
			  width="50%">
			  <el-row>
			    <el-form :model="form" v-loading="batchLoading">
					<el-form-item label="广告主账号" label-width="100px">
					   <el-select v-model="form.advertiser_id" @change="handleAccount" style="width:100%;" placeholder="请选择">
						<el-option
						  v-for="item in AccountList"
						  :key="item.advertiser_id"
						  :label="item.Fund.name"
						  :value="item.advertiser_id">
						  <span style="float: left">{{item.Fund.name}}</span>
						  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.advertiser_id }}</span>
						</el-option>
					  </el-select>
					</el-form-item>
					<el-form-item label="广告组系列" label-width="100px">
					  <el-select v-model="form.campaign_id" v-loading="campaignLoading" style="width:100%;" placeholder="请选择要复制的广告组">
						<el-option v-for="item in CampaignList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					  </el-select>
					</el-form-item>
				  </el-form>
			  </el-row>
			  <span slot="footer" class="dialog-footer">
				<el-button @click="dialogCopyVisible = false">取 消</el-button>
				<el-button type="primary" @click="ConfirmCopy">确 定</el-button>
			  </span>
			</el-dialog>
		   <el-table :data="adslist" border highlight-current-row v-loading="listLoading" height="450"  @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
            <el-table-column fixed label="计划ID" align="center" width="160">
				<template slot-scope="scope">
					{{scope.row.ad_id}}				
				</template>
			</el-table-column>			
			<el-table-column fixed label="广告计划名称" align="left" width="250">
			  <template slot-scope="scope">
			    <el-link @click="lookCreative(scope.row)" style="font-size:12px;" type="primary">{{scope.row.name}}</el-link>
			  </template>
			</el-table-column>			
			<el-table-column label="计划状态" align="center" width="160">
			 <template slot-scope="scope">			  
			  <span v-if="scope.row.status=='AD_STATUS_DELIVERY_OK'"><i style="color:#4dd599;font-size:7px;margin-right:2px;" class="fa fa-circle"></i> {{scope.row.statusName}}</span>
			  <span v-else ><i style="color:#999;font-size:7px;margin-right:2px;" class="fa fa-circle"></i> {{scope.row.statusName}}</span>
			  <span v-if="scope.row.learning_phase=='LEARNING'"><img :src="scope.row.learn_img"></span>
			  <span v-if="scope.row.status=='AD_STATUS_AUDIT_DENY'">
			    <el-tooltip class="item" effect="dark" :content="scope.row.audit_reject_reason" placement="top-start">
				 <i style="color:#ccc;cursor:pointer;" class="el-icon-warning"></i>
				</el-tooltip>			    
			  </span>
			 </template>
			</el-table-column>
			<el-table-column label="计划预算" align="center" min-width="80">
			 <template slot-scope="scope">
			    <span v-if="scope.row.budget_mode=='BUDGET_MODE_DAY'">{{scope.row.budget}}</span>
				<span v-else-if="scope.row.budget_mode=='BUDGET_MODE_INFINITE'">不限</span>
			 </template>
			</el-table-column>
			<el-table-column prop="report.cost" label="消耗(元)" sortable align="center" width="100">
			</el-table-column>
            <el-table-column  label="出价(元)" align="center" width="100">
			 <template slot-scope="scope">
			  <span>{{scope.row.cpa_bid}}</span>
			 </template>
			</el-table-column>			
			<el-table-column prop="report.show" sortable label="展示" align="center" width="100"></el-table-column>
			<el-table-column prop="report.click" sortable label="点击" align="center" width="100"></el-table-column>
			<el-table-column prop="report.convert" sortable label="转化数" align="center" width="100"></el-table-column>
			<el-table-column prop="report.cpi" sortable label="CPI" align="center" width="100"></el-table-column>
			<el-table-column prop="report.cpm" sortable label="CPM" align="center" width="100"></el-table-column>
			<el-table-column prop="report.ctr" sortable  label="CTR(%)" align="center" width="100"></el-table-column>
			<el-table-column prop="report.cvr" sortable label="CVR(%)" align="center" width="100"></el-table-column>
			<el-table-column label="性别" align="center" width="100">
			 <template slot-scope="scope">
			  <span>{{scope.row.audience.gender=='NONE'?'不限':scope.row.audience.gender=='GENDER_MALE'?'男':'女'}}</span>
			 </template>
			</el-table-column>
			<el-table-column prop="report.cvr"  label="所属广告组" align="center" width="230">
			  <template slot-scope="scope">
				<el-link style="font-size:12px;" type="primary">{{scope.row.report.campaign_name}}</el-link>
			 </template>
			</el-table-column>
			<el-table-column label="投放范围" align="center" width="200">
			  <template slot-scope="scope">
			    <el-tag style="font-size:10px;" effect="dark" :key="index" v-for="(item,index) in scope.row.inventory_type_name" size="mini">{{item}}</el-tag>
			 </template>
			</el-table-column>
			<el-table-column prop="flow_control_mode_name"  label="投放方式" align="center" width="120"></el-table-column>
			<el-table-column fixed label="操作" align="center" width="120" fixed="right">
				<template slot-scope="scope">
					<el-button type="text" style="color:#2F88FF;"  plain size="mini" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
					<el-button type="text" plain style="color:#6f9a8d;" @click="copyAds(scope.row)" size="mini">复制</el-button>
					<el-button type="text" style="color:#999;" size="mini">
						 <el-dropdown trigger="click">
						  <i class="fa fa-ellipsis-v"></i>
						  <el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="viewLog(scope.row)" icon="el-icon-document-copy">日志</el-dropdown-item>
							<el-dropdown-item icon="el-icon-circle-plus">诊断</el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
					</el-button>                   					
				</template>
			</el-table-column>
		</el-table>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-button type="success" @click="updateStatus('enable')" :disabled="this.sels.length===0" icon="el-icon-check" size="small">开启</el-button>
			<el-button type="warning" @click="updateStatus('disable')" icon="el-icon-video-pause" :disabled="this.sels.length===0" size="small">暂停</el-button>			
			<el-button type="danger" icon="el-icon-delete" @click="updateStatus('delete')" size="small" :disabled="this.sels.length===0">删除</el-button>			
			<el-pagination layout="total,sizes,prev, pager, next" @current-change="handleCurrentChange" @size-change="handleSizeChange" :page-size="pagesize" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		 <AdsEditPanel ref="AdsEditDrawer" @getAds="getAds"></AdsEditPanel>
		 <LogPanel ref="logDrawer"></LogPanel>
		</div>
</template>

<script>	
	import AdsEditPanel from './edit/index.vue'
	import LogPanel from './log/log.vue'
	import { getAdsListPage,updateAdStatus,copyAdsData,getAccountList,getCampaignListPage,batchCopyAdsData,getCreateRulesList,joinRule } from '../../../api/api';
	
	export default {
		components: {AdsEditPanel,LogPanel},
		props:{
		  PannelName: {
            type: String,
			default:''
		  },
		  campaign_obj:{
		   type: Object,
			default:{}
		  }
		},
		data() {
			return {
				sels:[],
				selsRule:[],
				total:0,
				type:'2',
				page:1,
				visible:false,
				form:{},
				dialogCopyVisible:false,
				RuleIdsLoading:false,
				batchLoading:false,
				AccountList:[],
				CampaignList:[],
				pagesize:10,
				gridData:[],
				listLoading:false,
				listRulesLoading:false,
				campaignLoading:false,
				adslist:[],	
			}
		},
		watch:{
		  PannelName:{
			 handler(val, oldVal){
			   if( val=='AdsPanel' )
			   {
			     this.getAds()
			   }
			 },
			 deep:true
		 }
		},
		computed:{
		   advertiser_id(){
		     return this.$store.getters.getAdvertiserId
		   },
		   userid(){
		    return this.$store.getters.getUserId
		  },
		  filtering(){
		     return this.$store.getters.getFiltering
		   }
		},
		methods: {
		  handleCurrentChange(val){
			  this.page = val
			  this.getAds()
			},
			handleSizeChange(val) {
			  this.pagesize = val
			  this.page = 1
			  this.getAds()
		  },
		  viewLog(row){
		    this.$refs['logDrawer'].openModel(row)
		  },
		  
		  lookCreative(row){
		    let params ={
			   type:'CreativePanel',
			   ad_obj:row
			}
			this.$emit('updatePannel',params)
		  },
		  allAds(){
		   this.$emit("updateData")
		   this.getAds(1)
		  },
		  confirmRules(){
		    let params ={
			  advertiser_id:this.advertiser_id,
			  type:this.type,
			  adIds:this.sels.map(item => item.id).toString(),
			  RuleIds:this.selsRule.map(item => item.id).toString()
			}
			this.RuleIdsLoading = true
			joinRule(params).then((res) => {
				this.RuleIdsLoading = false
				this.visible = false
				this.$message.success("加入成功!")				
			 });
		  },
		  getCreateRules(){
			  let params ={
			    page:1,
				pagesize:12
			  }
			  this.listRulesLoading = true
			  getCreateRulesList(params).then((res) => {
					this.listRulesLoading = false
					this.gridData = res.data.list				
			 });
			},
		  openCopyModal(){
		    this.getAccount()
			this.CampaignList =[]
			this.form ={}
			this.dialogCopyVisible = true
		  },
		  ConfirmCopy(){
		    if( !this.form.advertiser_id || !this.form.campaign_id )
			{
			  this.$message.error('请选择广告主账号或广告组系列!');
			  return false;
			}
			this.form.sels = this.sels
			this.batchLoading = true
			batchCopyAdsData(this.form).then((res) => {
					this.batchLoading = false
					if( res.code!=200 )
					{
					  this.$message.error(res.message);return false;
					}else{
					  this.dialogCopyVisible = false
					  this.$message.success("复制成功!")
					  this.page=1
					  this.sels =[]
					  this.getAds()
					}						
			 });
		  },
		  handleEdit(index,row){
		    this.$refs['AdsEditDrawer'].openEditDrawer(row)
		  },
		  handleAccount(val){
		    let para = {
					page:1,
					advertiser_id: val,
					page_size:500
				};
				this.campaignLoading = true;
				getCampaignListPage(para).then((res) => {					
					this.CampaignList = res.data.list;
					this.campaignLoading = false;
				});
		  },
		  getAccount()
		  {
			  if(  this.AccountList.length<1 )
			  {
				 let params ={
					userid:this.userid,
					channel:1
				 }				
				 getAccountList(params).then((res) => {
					 this.AccountList = res.data;
				});
			   }
		  },
		   selsChange: function (sels) {
				this.sels = sels;
			},
			selsRuleChange:function (sels) {
				this.selsRule = sels;
			},
		   copyAds(row){
		     copyAdsData(row).then((res) => {
					this.$message.success('操作成功');										  
					  this.page=1
					  this.sels =[]
					  this.getAds()						
			 });
		   },
		   cOpenDrawer(){
			  this.$emit('openDrawer')
			},
			updateStatus(status){
			  let ids = this.sels.map((item, i, arr) => {					
					return item.id
				})
			  let para = {
					type: 1,
					level:'ads',
					advertiser_id: this.advertiser_id,
					status:status,
					ids:ids
				};
                updateAdStatus(para).then((res) => {
					this.$message.success('操作成功');										  
					  this.page=1
					  this.sels =[]
					  this.getAds()						
				});				
			},
			getAds(id=0){			  
			  let para = {
					page: this.page,
					advertiser_id: this.advertiser_id,
					campaign_id:id==1?0:this.campaign_obj.id,
					filtering:this.filtering,
					page_size:this.pagesize
				};
				this.listLoading = true;
				getAdsListPage(para).then((res) => {
					this.total = res.data.page_info.total_number;
					this.adslist = res.data.list;
					this.listLoading = false;
				});
			}
		},
		mounted() {
				
		}
	}

</script>
<style  lang="scss">
  
</style>


// WEBPACK FOOTER //
// ads.vue?b515a6aa